$(function () {
    var defaultMenuEnabled = false;
    var pageIdElement = $('input[data-page-id]');
    var id = pageIdElement.data('page-id');

    // Har man klickat på mobilmenyn eller stängknappen ska man inte göra ett ny ajaxanrop
    if (defaultMenuEnabled === false) {
        // Kolla var nånstans man är i menyn och öppna alla föräldrar utom sig själv
        $('[data-page-id="' + id + '"]').css('font-weight', 'bold').closest('li').addClass('open').parents().addClass('open');

        $('li.nav-har-barn').click(function () {
            $(this).toggleClass('open');
        });

        // <li> ligger som wrapper runt <a> och för att undvika dubbla anrop använder jag e.stopPropagation()
        $('a.a-icon.a-icon-arrow').click(function (e) {
            if ($(this).attr('aria-expanded')) {
                if ($(this).attr('aria-expanded') === 'false') {
                    $(this).attr('aria-expanded', 'true');
                } else {
                    $(this).attr('aria-expanded', 'false');
                }
            } else {
                $(this).attr('aria-expanded', 'true');
            }

            $(this).parent().toggleClass('open');
            e.stopPropagation();
        });

        // Vill inte trigga bootstrapfunktionalitet
        $('[data-page-id="' + id + '"]').click(function (e) {
            e.stopPropagation();
        });

        $('a[data-page-id]').click(function (e) {
            if (!$(this).hasClass('blue-parent')) {
                e.stopPropagation();
            }
        });
    }
});

$(function () {
    $('.navbar-collapse').on('show.bs.collapse', function () {
        $('.navbar-collapse').not(this).collapse('hide');
    });

    $('.navbar-collapse .a-nav-side-level').attr('aria-hidden', 'true');

    $('.navbar-collapse .nav-har-barn a').click(function () {
        if ($(this).next('.a-nav-side-level').attr('aria-hidden') === 'false') {
            $(this).next('.a-nav-side-level').removeAttr('aria-hidden', 'false');
            $(this).next('.a-nav-side-level').attr('aria-hidden', 'true');
        } else {
            $(this).next('.a-nav-side-level').removeAttr('aria-hidden', 'true');
            $(this).next('.a-nav-side-level').attr('aria-hidden', 'false');
        }
    });
});

// Mobil Meny text - "Öppna" "Stäng"
$(function () {
    $('.navbar .container-fluid:last-of-type .navbar-toggle').attr('aria-expanded', 'false');
    $('.navbar .container-fluid:last-of-type .navbar-toggle').attr('aria-label', 'Öppna');

    $('.navbar .container-fluid:last-of-type .navbar-toggle').click(function () {
        if ($(this).attr('aria-label') === 'Öppna') {
            $(this).attr('aria-label', 'Stäng');
        } else {
            $(this).attr('aria-label', 'Öppna');
        }
    });
});
